
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { PlatformType, PlatformPayloadType } from "@/common/types/platform";

export async function platformList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `platform/list${queryString}`
    );
}

export async function platformGet(
    platform_id: string
) {
    return await clientAxios.get(
        `platform/${platform_id}/show`
    );
}

export async function platformAdd(
    payload: PlatformPayloadType
) {
    return await clientAxios.post(
        `platform/create`,
        payload
    );
}

export async function platformPatch(
    platform_id: string,
    payload: Partial<PlatformType>
) {
    return await clientAxios.patch(
        `platform/${platform_id}/patch`,
        { payload }
    );
}

export async function platformDel(
    platform_id: string,
) {
    return await clientAxios.del(
        `platform/${platform_id}/delete`,
    );
}
